var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank-wizard-container"},[(_vm.layoutH && _vm.showSteps)?_c('StepsH',{attrs:{"steps":_vm.steps}}):_vm._e(),(_vm.blankWelcome)?_c('Step0'):_vm._e(),(_vm.blankAlreadyFilled)?_c('Step7'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }